import { Slider } from "@/components/ui/slider";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { RotateCcw } from "lucide-react";

interface AdjustmentToolsProps {
  brightness: number;
  contrast: number;
  onBrightnessChange: (value: number) => void;
  onContrastChange: (value: number) => void;
  onReset: () => void;
}

export const AdjustmentTools = ({
  brightness,
  contrast,
  onBrightnessChange,
  onContrastChange,
  onReset,
}: AdjustmentToolsProps) => {
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="font-medium text-sm">Adjustments</h3>
        <Button
          variant="ghost"
          size="sm"
          onClick={onReset}
          title="Reset All"
        >
          <RotateCcw className="w-4 h-4" />
        </Button>
      </div>

      <div className="space-y-4">
        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label className="text-xs">Brightness</Label>
            <span className="text-xs text-muted-foreground">{brightness}</span>
          </div>
          <Slider
            value={[brightness]}
            onValueChange={([value]) => onBrightnessChange(value)}
            min={-100}
            max={100}
            step={1}
            className="w-full"
          />
        </div>

        <div className="space-y-2">
          <div className="flex items-center justify-between">
            <Label className="text-xs">Contrast</Label>
            <span className="text-xs text-muted-foreground">{contrast}</span>
          </div>
          <Slider
            value={[contrast]}
            onValueChange={([value]) => onContrastChange(value)}
            min={-100}
            max={100}
            step={1}
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
};
